import React, { useState, useRef, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';
import closeIcon from '../../assets/images/trains/kinds/ic_close_dialog.svg';
import { showDelayMinutes } from '../../services/delayService';

const DelayModal = ({ onClose, dateLabel, slotLabel, delayMinutes, issueDate, eventsEmit }) => {
  const [accordionOpen, setAccordionOpen] = useState(false);
  const contentRef = useRef(null);
  const body = document.body;

  body.style.position = 'fixed';

  useLayoutEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    if (accordionOpen) {
      el.style.maxHeight = el.scrollHeight + 'px';
      el.style.padding = '20px';
    } else {
      el.style.maxHeight = null;
      el.style.padding = '0 20px';
    }
  }, [accordionOpen]);

  const handleClose = (eventName, eventValue) => {
    eventsEmit(eventName, eventValue);
    body.style.position = '';

    onClose();
  };

  const toggleAccordion = (eventName, eventValue) => {
    setAccordionOpen((v) => !v);
    eventsEmit(eventName, eventValue);
  };

  return ReactDOM.createPortal(
    <div className="modal" role="dialog" aria-modal="true">
      <div className="modal-overlay" onClick={(e) => e.stopPropagation()}></div>
      <div className="modal-content">
        <div className="modal-header">
          <div className="date">{dateLabel}</div>

          <div className="modal-close">
            <span
              id="close-modal"
              className="close-button"
              onClick={
                () => handleClose('delay_certificate_detail.close', {})
              }
            >
              <img src={closeIcon} />
            </span>
          </div>
        </div>

        <div className="modal-body">
          <p>
            つくばエクスプレス線は、以下の通り遅延したことを証明いたします。ご迷惑をおかけし、大変申し訳ございませんでした。
          </p>

          <div className="info-table">
            <div className="delay-info">
              <p className="info-title">時間帯</p>
              <p className="info-time">{slotLabel}</p>
            </div>
            <div className="max-delay">
              <p className="info-title">最大遅延</p>
              <p className="info-time">{showDelayMinutes(delayMinutes)}</p>
            </div>
            <div className="company-info">
              <p>{issueDate}</p>
              <p>首都圏新都市鉄道株式会社</p>
            </div>
          </div>

          <div className="accordion">
            <button
              type="button"
              className={`accordion-header${accordionOpen ? ' active' : ''}`}
              onClick={ () => toggleAccordion('delay_certificate_detail.caution', {}) }
            >
              注意事項
              <div className="accordion-icon" />
            </button>

            <div
              className="accordion-content"
              ref={contentRef}
              style={{ maxHeight: 0, overflow: 'hidden', transition: 'max-height 0.3s ease' }}
            >
              <ul>
                <li>当証明書は、当社線の初電から終電までに運行している列車の遅延時間を証明するものです。</li>
                <li>当証明書は、当社線に5分以上の遅延時間が発生した場合に発行し、5分単位に切り上げて掲出いたします。</li>
                <li>当証明書は、当社線の遅延のみを証明するものであり、遅延によりお客さまに生じた損害等を賠償することを証明するものではありません。</li>
                <li>当社が発行したつくばエクスプレス線の乗車券以外の乗車券、航空券、旅行券の払い戻しについては、当該券面が効力を有する会社の規約・約款類によりますのでご注意ください。</li>
                <li>当社線で発生した最大の遅延時分を証明するものであり、個々の列車の遅延時分を証明するものではありません。また、お客様がご乗車されたことを証明するものでもありません。</li>
                <li>当社線各駅で発行している遅延証明書は、ホームページ遅延証明書の遅延時分とは異なる場合があります。</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body // Portal：body 直下へ
  );
};

export default DelayModal;
